<div *ngIf="user?.isTrialing" class="trial-banner">
  <span class="font-weight-600">{{userStripePlanName}} ({{trialEndsText}})</span>
  <div class="skip-container" *ngIf="(user.companyId <= 0 || user.isAccountOwner || user.isBillingManager)">
    <div class="skip-left">
      <span class="icon">⏱</span>
      <span>Skip Trial & Unlock All Credits</span>
    </div>
    <button class="btn btn-warning skip-btn" (click)="SkipTrial()">Skip Now</button>
  </div>
  <div style="min-width: 250px;">
    <div *ngIf="calculationUsageStats$ | async as calculationUsageStats">
      <div class="justify-content-between align-items-center mb-1" style="display: flex;gap:10px">
        <span class="m--font-boldest">{{calculationUsageStats.dllCallUsed}}
          of
          {{calculationUsageStats.dllCallLimit}}
          calculation credits used</span>
        <span class="text-muted small">{{calculationUsageStats.dllCallRemaining}}
          left</span>
      </div>
      <div class="progress m-progress--sm">
        <progress class="progress-bar usage-progress" [ngClass]="getDllUsageProgressColor(calculationUsageStats)"
          [value]="calculationUsageStats.dllCallUsed" [max]="calculationUsageStats.dllCallLimit" style="width: 100%;"
          [attr.aria-valuenow]="calculationUsageStats.dllCallUsed" [attr.aria-valuemin]="0"
          [attr.aria-valuemax]="calculationUsageStats.dllCallLimit"></progress>
      </div>
    </div>
  </div>

</div>